<template>
  <div class="home">
    <van-sticky>
      <van-nav-bar :title="title" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <van-cell-group>
      <van-field label="收货人" v-model="addressForm.name" placeholder="请输入收货人姓名" />
      <van-field label="手机号码" v-model="addressForm.phone" placeholder="请输入收货手机号码" />
      <van-field label="所在地区" v-model="msg" placeholder="请选择所在地区" @click="showProvince = true" />
      <van-field label="详细地址" v-model="addressForm.detail" placeholder="请输入详细地址" />
    </van-cell-group>
    <div class="submit-btn-container">
      <van-button @click="submitAddress">保存</van-button>
    </div>
    <van-popup v-model="showProvince" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="handleProvinceConfirm"
        @cancel="showProvince = false"
      />
    </van-popup>
  </div>
</template>

<script>
import areaList from "@/utils/area";
import { editAddress, addAddress,updateAddress } from "@/api/personal";
import { Dialog } from "vant";
export default {
  // filters: {
  //   formatAddress(value) {
  //     if (value.province) {
  //       return `${value.province} ${value.city} ${value.area}`;
  //     } else {
  //       return "";
  //     }
  //   }
  // },
  data() {
    return {
      title: "新增地址",
      showProvince: false,
      areaList: areaList,
      msg: "",
      addressForm: {
        id: "",
        name: "",
        phone: "",
        province: "",
        city: "",
        county: "",
        detail: "",
        address: ""
      },
      checked: false,
      addressId: ""
    };
  },
  created() {
    if (this.$route.query.item) {
      this.title = "编辑地址";
      this.addressForm = this.$route.query.item;
      let item=this.addressForm.address.split(' ');
      this.msg=item[0]+' '+item[1]+' '+item[2];
    } else {
      this.title = "新增地址";
    }
  },
  methods: {
    // 选中地址
    handleProvinceConfirm(e) {
      this.addressForm.province = e[0].name;
      this.addressForm.city = e[1].name;
      this.addressForm.county = e[2].name;
      this.msg = e[0].name +' '+ e[1].name +' '+ e[2].name;
      this.showProvince = false;
    },
    submitAddress() {
      if (this.title == "编辑地址") {
        this.addressForm.address = this.msg;
        updateAddress(this.addressForm).then(res => {
          this.$toast("修改成功");
          this.$router.go(-1);
        });
      } else {
        if (
          this.addressForm.name == "" ||
          this.addressForm.phone == "" ||
          this.addressForm.detail == ""
        ) {
          this.$toast("请填写完整信息");
          return;
        }
        this.addressForm.address = this.msg;
        addAddress(this.addressForm).then(res => {
          this.$toast("新增成功!");
          this.$router.go(-1);
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.home {
  background: #f9f9f9;
  width: 100%;
  height: 100vh;
}

.address-form {
  margin: 15px;
  background: white;
  border-radius: 10px;
  width: 345px;
  margin: 11px auto 160px;
  /deep/ .van-field__control:disabled {
    color: black;
  }

  .is-default {
    .van-cell__title {
      width: 90px;
      flex: none;
    }

    .van-cell__value {
      text-align: left;
    }
    .van-switch {
      font-size: 24px !important;
    }
  }
}
.van-dropdown-menu {
  height: 0.33333rem;
}
.submit-btn-container {
  width: 345px;
  line-height: 40px;
  bottom: 49px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  .van-button {
    background: #fe881e;
    width: 100%;
    border-radius: 20px;
    color: white;
    font-size: 18px;
  }
}
/deep/ .van-hairline--top-bottom::after {
  border-width: 0;
}
</style>
